import * as Sentry from "@sentry/capacitor";
import * as SentryVue from "@sentry/vue";
import { version, description } from '../../package.json'

// Dummy sentry object for development
// This will prevent errors when Sentry is not configured
const noop = () => {};
const dummySentry = {
  captureException: noop,
  captureMessage: noop,
}

// Set Sentry DSN (see SDK setup in Sentry.io) to .env.production
// and set VUE_APP_ENV=production in the same file

const WiseSentry = {
  install(app, options = {}) {
    if (import.meta.env.VITE_APP_ENV === "production"
      && import.meta.env.VITE_APP_SENTRY_DSN) {
      Sentry.init(
        {
          app,
          dsn: import.meta.env.VITE_APP_SENTRY_DSN,
          sendDefaultPii: true,
          release: description + "@" + version,
          dist: description,
          integrations: [],
          environment: import.meta.env.VITE_APP_ENV || 'production',
          ...options, // Allow user to override/add options
        },
        SentryVue.init,
      )
      app.config.globalProperties.$_SENTRY = Sentry
    } else {
      app.config.globalProperties.$_SENTRY = dummySentry
    }
  }
}

export default WiseSentry